import { useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { useParticleSelection, ParticleSelectionManager } from '@arkturian/wave-engine/core/ParticleSelectionManager';
import { EngineRuntime } from '@arkturian/wave-engine/core/EngineRuntime';

const runtime = EngineRuntime.getInstance();

/** Shared hook: selection + info + card position */
export function useInfoCardState() {
    const selection = useParticleSelection();

    useEffect(() => {
        runtime.ensureManifest().then(() => {
            ParticleSelectionManager.instance.setInfoProvider((index) => runtime.getParticleInfo(index));
        });
    }, []);

    const cardPos = useMemo(() => {
        if (!selection) return new THREE.Vector3();
        const n = selection.normal;
        const forward = 0.32;
        const up = new THREE.Vector3(0, 1, 0);
        const right = new THREE.Vector3().crossVectors(up, n).normalize();
        const down = new THREE.Vector3().crossVectors(n, right).normalize();
        return new THREE.Vector3(
            n.x * forward + right.x * 0.05 - down.x * 0.03,
            n.y * forward + right.y * 0.05 - down.y * 0.03,
            n.z * forward + right.z * 0.05 - down.z * 0.03,
        );
    }, [selection?.index]);

    return { selection, cardPos };
}
